import {IInsuranceFamilyContent} from "@/model/Content/InsuranceFamilyContent"

export interface IHasInsuranceFamilyContent {
    getInsuranceFamilyContent(): IInsuranceFamilyContent | null
    setInsuranceFamilyContent(content: IInsuranceFamilyContent): void
}

function hasInsuranceFamilyContent<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsuranceFamilyContent {
        private content: IInsuranceFamilyContent | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsuranceFamilyContent(): IInsuranceFamilyContent | null {
            return this.content
        }
        public setInsuranceFamilyContent(content: IInsuranceFamilyContent): void {
            this.content = content
        }
    };
}

export default hasInsuranceFamilyContent